<template>
  <div>
    <server-side-paginated-table
            :fields="table_settings.fields"
            :api_url="table_settings.api_url"
            :delete_url="table_settings.delete_url"
            :top_right_btn_redirect="false"
            ref="displayTable"
    />
    <b-modal v-model="modal" centered size="xl" modal-class="xxl-modal" body-class="p-4" :hide-footer="true" :hide-header="true">
      <b-row class="m-0 mb-3" v-if="typeof record.project !='undefined'">
        <b-col cols="6" class="p-0">
          <b-row class="m-0">
            <b-col cols="1" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
              <font-awesome-icon icon="road" class="h2 mb-0" />
            </b-col>
            <b-col class="p-3 bg-facebook text-white d-flex align-items-center">
              <div>
                <h4 class="mb-0"><strong>{{record.project.title}}</strong></h4>
                <small class="text-muted text-uppercase font-weight-bold">PROJECT TITLE</small>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="p-0 pl-3">
          <b-row class="m-0 h-100">
            <b-col cols="2" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
              <font-awesome-icon icon="calendar" class="h2 mb-0" />
            </b-col>
            <b-col class="p-3 bg-facebook text-white d-flex align-items-center">
              <div>
                <h4 class="mb-0"><strong>{{record.formatted_from_date.other_formats.format_1}}</strong></h4>
                <small class="text-muted text-uppercase font-weight-bold">FROM</small>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="p-0 pl-3">
          <b-row class="m-0 h-100">
            <b-col cols="2" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
              <font-awesome-icon icon="calendar" class="h2 mb-0" />
            </b-col>
            <b-col class="p-3 bg-facebook text-white d-flex align-items-center">
              <div>
                <h4 class="mb-0"><strong>{{record.formatted_to_date.other_formats.format_1}}</strong></h4>
                <small class="text-muted text-uppercase font-weight-bold">TO</small>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-tabs content-class="mt-3">
        <b-tab title="Included" active>
          <template v-for="(result, result_index) in result">
            <table class="table table-bordered">
              <thead>
              <tr class="bg-dark">
                <th colspan="12"><h5>{{result.date.other_formats.format_1}}</h5></th>
              </tr>
              <tr>
                <th>ID Number</th>
                <th>AM IN</th>
                <th>AM OUT</th>
                <th>PM IN</th>
                <th>PM OUT</th>
                <th>OT IN</th>
                <th>OT OUT</th>
                <th>REG</th>
                <th>OT</th>
                <th>ND</th>
                <th>AMOUNT</th>
                <th>Modify</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(log, log_index) in result.logs" v-if="!log.is_deleted">
                <td>
                  <div class="text-left">
                    <span class="d-block bg-dark text-white p-1" style="min-width: 300px">ID Number : <strong>{{log.manpower.id_number}}</strong></span>
                    <span class="d-block p-1">Name : <strong>{{log.manpower.full_name}}</strong></span>
                    <span class="d-block p-1">Location : <strong>{{log.location}}</strong></span>
                    <span class="d-block bg-dark text-white p-1">Structure : <strong>{{log.structure}}</strong></span>
                    <span class="d-block p-1">Item : <strong>{{log.item}}</strong></span>

                    <select class="form-control mb-2" v-model="log.job_description_id" required  :disabled="(!log.is_modified)" @change="updateRate(result_index,log_index)">
                      <option value="">Please Select</option>
                      <option v-for="job_description in job_descriptions" :value="job_description.id">
                        {{job_description.description}}
                      </option>
                    </select>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">Daily Rate</div>
                      </div>
                      <input type="number" class="form-control" id="inlineFormInputGroup" placeholder="Daily Rate" :readonly="(!log.is_modified)" step="any" v-model="log.daily_rate">
                    </div>
                  </div>
                </td>
                <td>
                  <template v-if="log.am_in!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.am_in_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_am_in.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.am_out!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.am_out_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_am_out.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.pm_in!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.pm_in_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_pm_in.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.pm_out!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.pm_out_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_pm_out.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.ot_in!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.ot_in_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_ot_in.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.ot_out!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.ot_out_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_ot_out.other_formats.format_1}}</span>
                  </template>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.regular_hours)" :currency="false"/> hour/s-->
                  <b-form-input
                          v-model="log.regular_hours"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                  <b-form-input
                          v-model="log.ot_hours"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                  <b-form-input
                          v-model="log.nd_hours"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.total)"/>-->
                  <b-form-input
                          v-model="log.total"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td>
                  <label class="c-switch c-switch-pill c-switch-success">
                    <input type="checkbox" class="c-switch-input" v-model="log.is_modified">
                    <span class="c-switch-slider"></span>
                  </label>
                </td>
                <td>
                  <b-button variant="danger" @click="log.is_deleted = !log.is_deleted">Exclude</b-button>
                </td>
              </tr>
              </tbody>
            </table>
          </template>
        </b-tab>
        <b-tab title="Excluded">
          <template v-for="(result, result_index) in result">
            <table class="table table-bordered">
              <thead>
              <tr class="bg-dark">
                <th colspan="12"><h5>{{result.date.other_formats.format_1}}</h5></th>
              </tr>
              <tr>
                <th>ID Number</th>
                <th>AM IN</th>
                <th>AM OUT</th>
                <th>PM IN</th>
                <th>PM OUT</th>
                <th>OT IN</th>
                <th>OT OUT</th>
                <th>REG</th>
                <th>OT</th>
                <th>ND</th>
                <th>AMOUNT</th>
                <th>Modify</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(log, log_index) in result.logs" v-if="log.is_deleted">
                <td>
                  <div class="text-left">
                    <span class="d-block bg-dark text-white p-1" style="min-width: 300px">ID Number : <strong>{{log.manpower.id_number}}</strong></span>
                    <span class="d-block p-1">Name : <strong>{{log.manpower.full_name}}</strong></span>
                    <span class="d-block p-1">Location : <strong>{{log.location}}</strong></span>
                    <span class="d-block bg-dark text-white p-1">Structure : <strong>{{log.structure}}</strong></span>
                    <span class="d-block p-1">Item : <strong>{{log.item}}</strong></span>

                    <select class="form-control mb-2" v-model="log.job_description_id" required  :disabled="(!log.is_modified)" @change="updateRate(result_index,log_index)">
                      <option value="">Please Select</option>
                      <option v-for="job_description in job_descriptions" :value="job_description.id">
                        {{job_description.description}}
                      </option>
                    </select>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">Daily Rate</div>
                      </div>
                      <input type="number" class="form-control" id="inlineFormInputGroup" placeholder="Daily Rate" :readonly="(!log.is_modified)" step="any" v-model="log.daily_rate">
                    </div>
                  </div>
                </td>
                <td>
                  <template v-if="log.am_in!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.am_in_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_am_in.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.am_out!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.am_out_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_am_out.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.pm_in!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.pm_in_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_pm_in.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.pm_out!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.pm_out_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_pm_out.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.ot_in!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.ot_in_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_ot_in.other_formats.format_1}}</span>
                  </template>
                </td>
                <td>
                  <template v-if="log.ot_out!=null">
                    <img
                            class="cursor-pointer"
                            :src="assets_path.EMPLOYEE_LOGS_URL+log.ot_out_image"
                            width="100px"
                    />
                    <span class="d-block">{{log.formatted_ot_out.other_formats.format_1}}</span>
                  </template>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.regular_hours)" :currency="false"/> hour/s-->
                  <b-form-input
                          v-model="log.regular_hours"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                  <b-form-input
                          v-model="log.ot_hours"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.ot_hours)" :currency="false"/> hour/s-->
                  <b-form-input
                          v-model="log.nd_hours"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td class="text-right">
                  <!--<number-format-component :input_value="Number(log.total)"/>-->
                  <b-form-input
                          v-model="log.total"
                          type="number"
                          step="any"
                          :readonly="(!log.is_modified)"
                          style="width: 100px;"
                  ></b-form-input>
                </td>
                <td>
                  <label class="c-switch c-switch-pill c-switch-success">
                    <input type="checkbox" class="c-switch-input" v-model="log.is_modified">
                    <span class="c-switch-slider"></span>
                  </label>
                </td>
                <td>
                  <b-button variant="success" @click="log.is_deleted = !log.is_deleted">Include</b-button>
                </td>
              </tr>
              </tbody>
            </table>
          </template>
        </b-tab>
      </b-tabs>

      <b-row>
        <b-col>
          <b-button type="submit" variant="danger" block size="sm" @click="reject()"><font-awesome-icon icon="times-circle" /> Reject</b-button>
        </b-col>
        <b-col>
          <b-button variant="success" block size="sm" @click="approve()" ><font-awesome-icon icon="save" /> Approve</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
  import {bus} from '@/main.js';
  import SwalMixin from '@/views/mixins/Swal.js'
  import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
  import ServerSidePaginatedTable from '@/views/helpers/ServerSidePaginatedTable.vue';
  import {assets_path} from '@/config';
  export default {
    mixins:[SwalMixin],
    components: {NumberFormatComponent,ServerSidePaginatedTable},
    data() {
      return {
        is_saving:false,
        modal:false,
        result:[],
        table_settings:{
          api_url:'import/for-approval',
          delete_url:'inventory/adjustments/delete',
          fields:[
            {key: 'project.title', label:'Project'},
            {key: 'formatted_from_date.other_formats.format_1', label:'From Date'},
            {key: 'formatted_to_date.other_formats.format_1', label:'To Date'}
          ]
        },
        record:{},
        assets_path:assets_path,
        job_descriptions:[]
      }
    },
    watch: {
      result:{
        immediate: true,
        deep:true,
        handler(){
          this.result.forEach( result => {

            result.logs.forEach( log => {
              let total_hours = Number(log.regular_hours) + Number(log.ot_hours);
              let total = total_hours * (Number(log.daily_rate)/8);
              log.total = total.toFixed(2);
            });
          });
        }
      },
    },
    created(){
      this.getJobDescriptions();
      bus.$on('serverSidePaginatedTableTopRightBtnClicked', (data)=>{
        this.modal = true;
      });
      bus.$on('serverSidePaginatedTableDbClick', (data)=>{
        this.record = JSON.parse(JSON.stringify(data));
        this.getTimeLogs(this.record.id);
        this.modal=true;
      });
    },
    methods: {
      get(){
        this.$refs.displayTable.getAll();
        this.modal=false;
      },
      save(){
        this.get();
      },
      getJobDescriptions(){
        this.axios.get('maintenance/job_descriptions/all').then(response => {
          this.job_descriptions=response.data
        }).catch(error => console.log(error));
      },
      getTimeLogs(id){
        this.axios.get('import/time-logs',{ params: { id: id } }).then(response => {
          this.result=response.data
        }).catch(error => console.log(error));
      },
      updateRate(result_index,log_index){
        let job_description = this.job_descriptions.find(result => result.id === this.result[result_index].logs[log_index].job_description_id);
        this.result[result_index].logs[log_index].daily_rate = job_description.daily_rate.default;
      },
      approve(){
        this.swalConfirmSubmit((data)=>{
          if (data.value) {
            let form = {
              json_import:this.record,
              result:this.result
            }
            this.axios.post('import/approve',form).then(response => {
              this.swalTransactionCompleted();
              this.get();
            }).catch(error => {
              console.log(error)
              this.swal_transaction_error_data.text = error.response.data;
              this.swalRequestError();
            });
          }
        });
      },
      reject(){
        this.swalConfirmSubmit((data)=>{
          if (data.value) {
            this.axios.delete('import/delete',{ data: {id:this.record.id} }).then(response => {
              this.swalTransactionCompleted();
              this.get();
            }).catch(error => {
              console.log(error)
              this.swal_transaction_error_data.text = error.response.data;
              this.swalRequestError();
            });
          }
        });
      },
    }
  }
</script>
